import { Box, CircularProgress, Paper, Skeleton, Typography } from "@mui/material";

export function RouteLoadingFallback() {
  return (
    <Box className="min-h-[calc(100vh-117px)] bg-stone-100 p-3 sm:p-5" aria-live="polite" aria-busy="true">
      <Paper variant="outlined" className="mx-auto max-w-[1700px] p-5" elevation={0}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
          <CircularProgress size={22} thickness={5} />
          <Typography sx={{ fontWeight: 900 }}>Loading workspace…</Typography>
        </Box>
        <Skeleton variant="rounded" height={132} />
        <Box className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
          {Array.from({ length: 8 }, (_, index) => <Skeleton key={index} variant="rounded" height={110} />)}
        </Box>
      </Paper>
    </Box>
  );
}
